import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { DISH_TYPE_QUERY } from '../graphql/queries'
import { FETCH_DISH_TYPE } from '../redux/action-types'
import { cleanupFetchDishType } from '../redux/actions'

const useDishTypeQuery = id => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchDishType)

  const { isFetchLoading, fetchError, data } = useSelector(
    store => store.dishTypes.dishType,
  )

  const refetch = useCallback(
    id =>
      apolloService.query(DISH_TYPE_QUERY, { id }, dispatch, FETCH_DISH_TYPE),

    [dispatch],
  )

  useEffect(() => {
    refetch(id)
  }, [id, refetch])

  return { isLoading: isFetchLoading, error: fetchError, data, refetch }
}

export default useDishTypeQuery
